import * as React from "react";
import styled from "styled-components";
import { Alert, Button } from "components/bootstrap";
import { LinkContainer } from "components/common";
import usePermissions from "hooks/usePermissions";
import useModelProviderConfig from "ai-management/hooks/useModelProviderConfig";
import useEnabledWorkflowCount from "aiagent/hooks/useEnabledWorkflowCount";
import { hasConfiguredModelProvider } from "ai-management/utils";
import AIManagementRoutes from "ai-management/Routes";
const StyledAlert = styled(Alert)`
  margin-top: 0;
`;
const AlertContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacings.sm};
`;
const ProviderAlert = () => {
  const { data: modelProviderConfig, isLoading } = useModelProviderConfig();
  const { data: enabledWorkflows, isLoading: countLoading } = useEnabledWorkflowCount();
  if (isLoading || countLoading || hasConfiguredModelProvider(modelProviderConfig)) {
    return null;
  }
  const anyEnabled = enabledWorkflows > 0;
  return /* @__PURE__ */ React.createElement(StyledAlert, { bsStyle: anyEnabled ? "danger" : "info", title: "Model provider configuration is missing" }, /* @__PURE__ */ React.createElement(AlertContent, null, /* @__PURE__ */ React.createElement("span", null, anyEnabled ? "Model provider configuration is missing, workflows will not run." : "Model provider configuration is missing. No workflows are enabled."), /* @__PURE__ */ React.createElement(LinkContainer, { to: AIManagementRoutes.MODEL_PROVIDERS }, /* @__PURE__ */ React.createElement(Button, { bsSize: "small" }, "Configure Provider"))));
};
const ModelProviderRequiredAlert = () => {
  const { isPermitted } = usePermissions();
  return isPermitted("llm_provider:edit") ? /* @__PURE__ */ React.createElement(ProviderAlert, null) : null;
};
export default ModelProviderRequiredAlert;
